import { render, staticRenderFns } from "./componete-uf-cidade-bairro.vue?vue&type=template&id=bd58fd22"
import script from "./componete-uf-cidade-bairro.vue?vue&type=script&lang=js"
export * from "./componete-uf-cidade-bairro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports